import { useEffect } from 'react';
import { useGlobalSettings, useInitialiseApp } from '../hooks';
import { useHeadsetContext } from "../../../context/HeadsetContext/context";
import { useTypedSelector } from "../../../redux/hooks";
import {
    selectAllCalls,
    selectCurrentUserId,
} from "../../../redux/slices";
import { useHotkeyContext } from "../../../context/HotKeysContext/context";
import { useDnd } from "../../../helpers";
import { useGetQueuePanelDataQuery } from '../../../redux/services/queueApi';
import { selectSortedQueuePanels } from '../../../redux/slices/queueSlice';

interface Props {
    setIsLoaded: (val: boolean) => void;
}

const HomeReRenderOffLoad: React.FC<Props> = ({ setIsLoaded }) => {
    const { reportValues } = useHeadsetContext();
    const { hotKeyNavigate } = useHotkeyContext();

    useInitialiseApp({ setIsLoaded });
    useGlobalSettings();

    const calls = useTypedSelector(selectAllCalls);
    const voip_user_uuid = useTypedSelector(selectCurrentUserId);
    const panelCount = useTypedSelector(state => selectSortedQueuePanels(state)?.length || 0) || 0;

    useGetQueuePanelDataQuery({ voip_user_uuid }, {
        skip: panelCount < 1,
        pollingInterval: 5_000
    });

    const {
        localDnd,
        globalDnd,
        dndDisabled,
        updateDnd
    } = useDnd();

    useEffect(() => {
        if (!dndDisabled) return;

        if (globalDnd) {
            updateDnd(false, true);
        }

        if (localDnd) {
            updateDnd(false, false);
        }
    }, [dndDisabled, globalDnd, localDnd]);

    useEffect(() => {
        if (globalDnd && localDnd) {
            updateDnd(false, false);
        }
    }, [globalDnd, localDnd]);

    useEffect(() => {
        if (calls.length > 0) return;

        hotKeyNavigate('keypad');
    }, [reportValues.length]);

    return null;
};

export default HomeReRenderOffLoad;
